import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateClientProviderDocsReport =
  (apiData) => async (dispatch) => {
    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
        },
        url: `${actionType.environment_url}/api/admin/client/GenerateClientProviderDocsReport`,
        params: {
          ...apiData,
          // status: apiData.status.replace(/\s+/g, "_"),
          client_org_ids: JSON.stringify(
            apiData.client_org_ids?.map((item) => item?.organisation_id)
          ),
          provider_org_ids: JSON.stringify(
            apiData.provider_org_ids?.map((item) => item?.provider_org_id)
          ),
          provider_type_ids: JSON.stringify(apiData.provider_type_ids),
          document_ids: JSON.stringify(apiData.document_ids),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };

export const TriggerClientProviderDocsReport =
  (apiData) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
        },
        url: `${actionType.environment_url}/api/admin/TriggerClientProviderDocsReport`,
        data: {
          ...apiData,
          client_org_ids: JSON.stringify(
            apiData.client_org_ids?.map((item) => item?.organisation_id)
          ),
          provider_org_ids: JSON.stringify(
            apiData.provider_org_ids?.map((item) => item?.provider_org_id)
          ),
          provider_type_ids: JSON.stringify(apiData.provider_type_ids),
          document_ids: JSON.stringify(apiData.document_ids),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };
